import React, { useEffect, useState } from "react";
import { Box, Typography, useTheme } from "@material-ui/core";
import _ from "lodash";

import withAuthority from "../../../../components/Auth/withAuthority";
import Authorities from "../../../../auth/authorities";
import DefaultAlert from "../../../../components/alerts/DefaultAlert";
import { useParams, useRouteMatch } from "react-router";
import { ERROR_MESSAGE_UNEXPECTED_ERROR } from "../../../../utils/consts";
import { fetchAllFilterLocations } from "../../../../services/locationApp/locationFilterService";
import { getCookie } from "../../../../utils/cookies";
import { voidSummeryFilterObject } from "../../../../utils/consts/list";
import { CustomTheme } from "../../../../types/customTheme";
import SaleReport from "../../../../components/common/SaleReport";
import { getFilterListFromArrayObject } from "../../../../utils/commonArrayMap";
import { fetchAllVoidSummeryInfo } from "../../../../services/salesApp/voidSummeryServices";
import { fetchAllVGetLogsInfo } from "../../../../services/salesApp/logsService";
import { fetchAllUserInfo } from "../../../../services/salesApp/salesService";
import LogDetailsInfo from "./LogDetailsInfo";

/**
 * LogDetails Component:
 *
 * This component is responsible for displaying the VAT summary report for void transactions.
 * It retrieves void summary information from the backend API based on the selected filters
 * such as location, date range, etc., and presents the data in a tabular format.
 */
const LogDetails: React.FunctionComponent<{}> = () => {
  const [error, setError] = useState("");
  const [orderId, setOrderId] = useState("");
  const [logsNode, setLogsNode] = useState([]);
  const [genericNode, setGenericsNode] = useState([]);
  const [kdsLogs, setKdsLogs] = useState([]);
  const [userDetails, setUserDetails] = useState<any>({});
  const [isLoading, setIsLoading] = useState(true);
  const [locationSelectorList, setLocationSelectorList] = useState([]);
  const [isGeneric, setIsGeneric] = useState(false);
  const [isOrderLogs, setIsOrderLogs] = useState(false);
  const [isKdsLogs, setIsKdsLogs] = useState(false);
  const match: any = useRouteMatch();
  const idToken = getCookie("idToken");
const params: any = useParams();
 
const getAllFilterLocation = async (searchName: any) => {
    fetchAllFilterLocations("")
      .then((res) => {
        let locationList: any = [];
        /* Setting up the list of locations as needed to select locations. */
        if (!_.isEmpty(res.data.data)) {
          res.data.data.map((location: any) =>
            locationList.push({
              id: location.id,
              label: location.businessDisplayName,
            }),
          );
        }
        setLocationSelectorList(locationList);
      })
      .catch(() => {
        setError(ERROR_MESSAGE_UNEXPECTED_ERROR);
      });
  };
  
const getUserInfo = async () => {
    try {
      const res = await fetchAllUserInfo(idToken, match.params.locationId);
      setUserDetails(res.data.data);
      getAllFilterLocation([match.params.locationId]);
    } catch (err) {
      setError(ERROR_MESSAGE_UNEXPECTED_ERROR);
      setIsLoading(false);
    }
  };
 

  const handleOrderKeyClick = async (key: string) => {
    setOrderId(key);
    setIsLoading(true);
    try {
      const id = key.replace(".", "_");
      const res: any = await fetchAllVGetLogsInfo(match.params.locationId, id);
      setLogsNode(res.data.data);
      setIsLoading(false);
      setIsGeneric(false);
      setIsOrderLogs(false);
    } catch (error) {
      setError(ERROR_MESSAGE_UNEXPECTED_ERROR);
      setIsLoading(false);
    }
  };

 

  useEffect(() => {
    document.title = "Sale - Logs";

    getUserInfo()
  }, []);

   useEffect(() => {
    // Check if there's an orderId in the URL (e.g., /logs/719_642)
    const urlOrderId = params.orderId;
    
    if (urlOrderId && urlOrderId !== orderId) {
      console.log("Loading order from URL:", urlOrderId);
      // Set the orderId state and fetch logs for this order
      setOrderId(urlOrderId);
      handleOrderKeyClick(urlOrderId);
      // Set isOrderLogs to true to show the order logs view
      setIsOrderLogs(true);
    }
  }, [params.orderId]);
  const handleSubmitGeneric = () => {
    setIsGeneric(true);
    setLogsNode(genericNode);
    setIsOrderLogs(false);
  };

  const handleSubmitKds = () => {
    setIsGeneric(true);
    setLogsNode(kdsLogs);
    setIsOrderLogs(false);
  };

  const handleSubmitOrderLogs = () => {
    setLogsNode([]);
    setIsOrderLogs(true);
    setOrderId("");
  };
  const theme: CustomTheme = useTheme();
  return (
    <>
      <Box>
        <Typography
          variant="h4"
          style={{ fontWeight: "bold", cursor: "pointer", marginTop: "16px" }}
          color="secondary"
          align="left"
        >
          Logs
        </Typography>
        <LogDetailsInfo
          logsNode={logsNode}
          userDetails={userDetails}
          isLoading={isLoading}
          locationSelectorList={locationSelectorList}
          isGeneric={isGeneric}
          isOrderLogs={isOrderLogs}
          handleOrderKeyClick={handleOrderKeyClick}
        />
        <DefaultAlert
          open={!!error}
          handleClose={() => setError("")}
          message={error}
          severity="error"
        />
      </Box>
    </>
  );
};

export default withAuthority(LogDetails, Authorities.SALE_READ);
